var _rect, _rect2, _g, _g2, _defs, _g3, _g4, _g5, _defs2, _linearGradient, _g6, _g7, _defs3, _g8, _g9, _g10, _defs4, _linearGradient2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2000,
    height: 2250,
    viewBox: "0 0 2000 2250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.410605131648481e-13,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 2250,
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 360,
    fill: "url(#be39c56c-9ba1-4356-9d84-da4f84de2937)",
    mask: "url(\"#4cf1a554-504f-48fe-a263-1f74bbb8b6ae\")",
    "data-fill-palette-color": "tertiary"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 360,
    fill: "url(#09876789-79e1-4277-9fa3-6dc3b047cce7)",
    mask: "url(\"#ce9a3c92-3d85-481e-aa06-3492e823cd92\")",
    "data-fill-palette-color": "primary"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M20.961 227.22l3.726 4.658-1.863-6.056c-0.466-2.795-3.726 0.466-1.863 1.398M25.153 224.425c1.397 2.329 2.795 4.658 2.795 6.987 0 3.261 2.795 4.658 5.123 5.589-3.261-3.726-5.124-13.974-7.918-12.576M204.017 26.929c7.918 0 15.371-0.932 23.756 0.931 20.495 5.124 37.729 15.371 49.374 29.811l32.606 52.169c1.397 13.042 4.192 27.482 3.726 43.319 3.261 0 2.795-4.658 6.521-5.59-3.726 9.316-5.59 20.961-6.521 34.469-2.329-7.453 0-18.632 0.466-24.687-3.261 5.124-5.124 1.397-5.124-0.932 0.466-3.726-1.397-3.261-2.795-4.658-5.124-4.658-8.384-9.782-12.11-17.7 2.329-6.055 2.795-14.905-4.658-19.563-2.329-1.397-5.124-3.726-6.521-7.453-1.863-5.124-5.124-11.179-4.193-19.097 0.466-2.329-6.987 5.124-11.179 1.863-18.166-12.576-36.332-27.016-58.224-39.127-11.645 0-20.029-4.192-24.221-9.316-3.726-4.658-0.932-10.713 4.658-11.179 3.261 0 6.987-0.932 9.782 0.932 0.466-1.863 2.329-4.192 4.657-4.192M157.904 16.215l0.932 0.466c4.658 0.932 6.987 7.453 12.11 5.124 0 3.261 0.466 6.521-0.466 8.85-1.397 3.726-5.59 3.726-8.85 3.726-31.208-1.863-49.374 11.179-68.471 22.358-5.124 3.261-10.713 5.59-14.906 9.782-20.029 18.632-41.921 35.866-47.045 70.335l-4.192 38.195c-0.466 4.192-5.124 8.384-4.192 13.508l3.26 22.824c-3.261-3.261-5.124 0.932-4.192 2.795 0.466 1.397 2.329 6.055 5.124 1.863 3.726 6.987 7.453 20.495 12.576 26.55 15.837 18.632 36.332 35.4 53.101 52.169 4.192-0.932 7.453-0.932 8.384-3.727 1.397 2.795-1.397 5.59-3.726 6.056 7.453 4.658 15.837 8.85 27.016 9.781 14.44 0.932 27.948 3.261 40.524 6.522 6.521-1.863 13.042-2.795 20.029-3.261 2.329 0 3.726-3.726 6.521-4.658l0.466-4.658c2.795 4.192 2.329-1.397 0.466-4.192 3.261 2.795 4.192 5.124 5.589 6.987 0-1.397 3.726-6.521 3.727-0.466l0.931-6.055c1.397-0.932 1.863 5.124 3.261 0.931 1.397-4.192 4.192-0.932 6.987-2.329-0.932 1.863-0.466 5.59 2.794 3.261l3.727-3.261c2.329 5.59 6.055 3.261 7.918 2.329 20.495-13.042 40.99-28.413 60.553-43.784l-0.466 6.055 2.329-7.453c2.329 2.329 4.192 0.466 5.124-0.931 2.795-4.658 6.521-9.316 12.577-13.508-7.453 20.029-16.303 35.866-27.482 48.908l-4.658 5.59c0 3.261-0.932 7.453-4.658 7.918-1.863 0.466-5.59-0.932-8.384 1.863-1.397 1.863 3.261 5.59-0.466 2.795-3.261-2.329-6.521 0-10.248 0.932-2.795 0.932 1.863 3.726 2.795 5.589 0.932 1.863 1.863 3.726 1.398 6.056l-5.124-5.59c-6.055 3.261-9.782 9.316-14.906 13.974-2.329 1.863-1.397 5.124-1.397 7.918-3.261 0-6.987-0.932-8.85 0.932-1.397 1.863-0.932 4.658-0.932 7.453-4.658-0.466-5.124-7.453-9.315-6.056-4.192 0.932-8.85 1.397-12.577 3.727 2.795 5.59-4.658 2.329-3.726 3.26-6.987-4.192-13.042-7.453-20.495-4.658-15.837-5.124-35.4-2.795-49.84-0.931 0-2.329 0.466-4.658-0.466-5.124-0.932 2.329-3.726 1.397-3.26 1.397-8.85-6.055-17.7-9.782-27.016-14.905-8.384 0.932-16.303-3.261-18.632-5.59-6.521-6.055-13.974-2.795-20.029-4.192-13.042-3.261-17.7-16.769-19.098-26.084-0.932-4.658-4.658-6.521-6.055-6.056-6.055-19.563-15.371-37.263-22.824-55.429-1.863-4.658-1.397-9.316-1.397-14.44 2.329 0.932 4.658 0.466 4.192-2.794-2.329-15.371-7.918-27.016-13.974-38.195 3.261-15.837 3.726-34.469 11.179-48.443 6.521-12.576 18.632-19.098 27.016-29.811 2.795-3.726 2.795-8.85 5.59-12.11 9.316-9.316 18.632-19.098 28.879-27.482 4.658-3.726 10.247 0 17.234-1.397 2.329-8.384 11.645-15.837 20.495-13.508 3.726 0.932 11.179-8.85 13.508-9.782 3.726-1.397 1.863 3.726 1.863 6.987 8.85-6.987 20.961-10.713 32.14-14.906",
    fill: "url(#be39c56c-9ba1-4356-9d84-da4f84de2937)",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.6,90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.8,
    viewBox: "-0.8400000333786011 -30.959999084472656 29.040000915527344 44",
    height: 180,
    "data-palette-color": "url(#09876789-79e1-4277-9fa3-6dc3b047cce7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("mask", {
    id: "ce9a3c92-3d85-481e-aa06-3492e823cd92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1445"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.6,90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1444"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    id: "SvgjsSvg1443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.8,
    viewBox: "-0.8400000333786011 -30.959999084472656 29.040000915527344 44",
    height: 180,
    "data-palette-color": "url(#09876789-79e1-4277-9fa3-6dc3b047cce7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "SvgjsG1442"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36-17.76L9.36-17.76Q7.16-18.28 5.84-19.6L5.84-19.6Q4.4-21.12 4.4-23.16L4.4-23.16Q4.4-26.48 6.6-28.24L6.6-28.24Q7.88-29.24 9.48-29.24L9.48-29.24Q9.84-29.24 10.04-29.02 10.24-28.8 10.28-28.36L10.28-28.36Q8.64-28.36 7.44-27.08L7.44-27.08Q5.92-25.44 5.92-23.4L5.92-23.4Q5.92-22.16 6.76-20.74 7.6-19.32 9.76-18.8L9.76-18.8Q11.84-24 15.02-27.48 18.2-30.96 21.6-30.96L21.6-30.96Q24.52-30.96 25-28.56L25-28.56Q25.12-28.08 25.12-27.6L25.12-27.6Q25.12-25.52 23.28-23.04L23.28-23.04Q20.48-19.2 15.56-17.96L15.56-17.96Q14.08-17.6 12.48-17.52L12.48-17.52Q10.72-12.08 10.72-7.28 10.72-2.48 12.92-2.48L12.92-2.48Q14.44-2.48 16.4-4.6 18.36-6.72 20.08-9.84L20.08-9.84Q23.44-16 24.76-19.52L24.76-19.52Q25.36-21 25.94-21.72 26.52-22.44 27.36-22.44 28.2-22.44 28.2-21.52L28.2-21.52Q26.76-18.12 25.4-10.12L25.4-10.12Q24-2.6 23.28-0.4 22.56 1.8 21.8 3.66 21.04 5.52 20.2 6.74 19.36 7.96 18.18 9.26 17 10.56 15.68 11.32L15.68 11.32Q12.64 13.04 8.88 13.04L8.88 13.04Q2.64 13.04 0.28 8.88L0.28 8.88Q-0.84 7-0.84 5.3-0.84 3.6-0.44 2.24L-0.44 2.24Q0.52-0.88 2.96-1.96L2.96-1.96Q3.88-2.32 4.6-2.32L4.6-2.32Q5.88-2.32 6.08-1.52L6.08-1.52 6.12-1.28Q3.64-1.28 2.24 1.44L2.24 1.44Q1.32 3.2 1.32 4.68L1.32 4.68Q1.32 10.48 6.24 11.8L6.24 11.8Q7.44 12.12 8.84 12.12L8.84 12.12Q11.6 12.12 13.78 10.68 15.96 9.24 17.24 7.56 18.52 5.88 19.68 2.36 20.84-1.16 21.26-3.04 21.68-4.92 22.1-7.12 22.52-9.32 22.56-9.48 22.6-9.64 22.64-9.86 22.68-10.08 22.74-10.5 22.8-10.92 23.04-11.84L23.04-11.84 22.64-11.84Q20.24-7.28 17.56-4.2 14.88-1.12 12.56-1.12 10.24-1.12 9-2.6L9-2.6Q7.44-4.48 7.44-8.52 7.44-12.56 9.36-17.76ZM21.6-29.8L21.6-29.8Q19.08-29.8 16.78-26.62 14.48-23.44 12.84-18.6L12.84-18.6Q17.96-18.96 21.28-22.72L21.28-22.72Q23.6-25.32 23.6-27.72L23.6-27.72Q23.36-29.68 21.6-29.8Z",
    fill: "white"
  }))))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", null)))))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    id: "09876789-79e1-4277-9fa3-6dc3b047cce7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f00b51",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#730062",
    offset: 1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "4cf1a554-504f-48fe-a263-1f74bbb8b6ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1453"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M20.961 227.22l3.726 4.658-1.863-6.056c-0.466-2.795-3.726 0.466-1.863 1.398M25.153 224.425c1.397 2.329 2.795 4.658 2.795 6.987 0 3.261 2.795 4.658 5.123 5.589-3.261-3.726-5.124-13.974-7.918-12.576M204.017 26.929c7.918 0 15.371-0.932 23.756 0.931 20.495 5.124 37.729 15.371 49.374 29.811l32.606 52.169c1.397 13.042 4.192 27.482 3.726 43.319 3.261 0 2.795-4.658 6.521-5.59-3.726 9.316-5.59 20.961-6.521 34.469-2.329-7.453 0-18.632 0.466-24.687-3.261 5.124-5.124 1.397-5.124-0.932 0.466-3.726-1.397-3.261-2.795-4.658-5.124-4.658-8.384-9.782-12.11-17.7 2.329-6.055 2.795-14.905-4.658-19.563-2.329-1.397-5.124-3.726-6.521-7.453-1.863-5.124-5.124-11.179-4.193-19.097 0.466-2.329-6.987 5.124-11.179 1.863-18.166-12.576-36.332-27.016-58.224-39.127-11.645 0-20.029-4.192-24.221-9.316-3.726-4.658-0.932-10.713 4.658-11.179 3.261 0 6.987-0.932 9.782 0.932 0.466-1.863 2.329-4.192 4.657-4.192M157.904 16.215l0.932 0.466c4.658 0.932 6.987 7.453 12.11 5.124 0 3.261 0.466 6.521-0.466 8.85-1.397 3.726-5.59 3.726-8.85 3.726-31.208-1.863-49.374 11.179-68.471 22.358-5.124 3.261-10.713 5.59-14.906 9.782-20.029 18.632-41.921 35.866-47.045 70.335l-4.192 38.195c-0.466 4.192-5.124 8.384-4.192 13.508l3.26 22.824c-3.261-3.261-5.124 0.932-4.192 2.795 0.466 1.397 2.329 6.055 5.124 1.863 3.726 6.987 7.453 20.495 12.576 26.55 15.837 18.632 36.332 35.4 53.101 52.169 4.192-0.932 7.453-0.932 8.384-3.727 1.397 2.795-1.397 5.59-3.726 6.056 7.453 4.658 15.837 8.85 27.016 9.781 14.44 0.932 27.948 3.261 40.524 6.522 6.521-1.863 13.042-2.795 20.029-3.261 2.329 0 3.726-3.726 6.521-4.658l0.466-4.658c2.795 4.192 2.329-1.397 0.466-4.192 3.261 2.795 4.192 5.124 5.589 6.987 0-1.397 3.726-6.521 3.727-0.466l0.931-6.055c1.397-0.932 1.863 5.124 3.261 0.931 1.397-4.192 4.192-0.932 6.987-2.329-0.932 1.863-0.466 5.59 2.794 3.261l3.727-3.261c2.329 5.59 6.055 3.261 7.918 2.329 20.495-13.042 40.99-28.413 60.553-43.784l-0.466 6.055 2.329-7.453c2.329 2.329 4.192 0.466 5.124-0.931 2.795-4.658 6.521-9.316 12.577-13.508-7.453 20.029-16.303 35.866-27.482 48.908l-4.658 5.59c0 3.261-0.932 7.453-4.658 7.918-1.863 0.466-5.59-0.932-8.384 1.863-1.397 1.863 3.261 5.59-0.466 2.795-3.261-2.329-6.521 0-10.248 0.932-2.795 0.932 1.863 3.726 2.795 5.589 0.932 1.863 1.863 3.726 1.398 6.056l-5.124-5.59c-6.055 3.261-9.782 9.316-14.906 13.974-2.329 1.863-1.397 5.124-1.397 7.918-3.261 0-6.987-0.932-8.85 0.932-1.397 1.863-0.932 4.658-0.932 7.453-4.658-0.466-5.124-7.453-9.315-6.056-4.192 0.932-8.85 1.397-12.577 3.727 2.795 5.59-4.658 2.329-3.726 3.26-6.987-4.192-13.042-7.453-20.495-4.658-15.837-5.124-35.4-2.795-49.84-0.931 0-2.329 0.466-4.658-0.466-5.124-0.932 2.329-3.726 1.397-3.26 1.397-8.85-6.055-17.7-9.782-27.016-14.905-8.384 0.932-16.303-3.261-18.632-5.59-6.521-6.055-13.974-2.795-20.029-4.192-13.042-3.261-17.7-16.769-19.098-26.084-0.932-4.658-4.658-6.521-6.055-6.056-6.055-19.563-15.371-37.263-22.824-55.429-1.863-4.658-1.397-9.316-1.397-14.44 2.329 0.932 4.658 0.466 4.192-2.794-2.329-15.371-7.918-27.016-13.974-38.195 3.261-15.837 3.726-34.469 11.179-48.443 6.521-12.576 18.632-19.098 27.016-29.811 2.795-3.726 2.795-8.85 5.59-12.11 9.316-9.316 18.632-19.098 28.879-27.482 4.658-3.726 10.247 0 17.234-1.397 2.329-8.384 11.645-15.837 20.495-13.508 3.726 0.932 11.179-8.85 13.508-9.782 3.726-1.397 1.863 3.726 1.863 6.987 8.85-6.987 20.961-10.713 32.14-14.906",
    fill: "white",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.6,90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1452"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    id: "SvgjsSvg1451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.8,
    viewBox: "-0.8400000333786011 -30.959999084472656 29.040000915527344 44",
    height: 180,
    "data-palette-color": "url(#09876789-79e1-4277-9fa3-6dc3b047cce7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "SvgjsG1450"
  })))))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", null))), /*#__PURE__*/React.createElement("mask", null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1449"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 360",
    height: 360,
    width: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.6,90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1448"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    id: "SvgjsSvg1447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118.8 180",
    height: 180,
    width: 118.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.8,
    viewBox: "-0.8400000333786011 -30.959999084472656 29.040000915527344 44",
    height: 180,
    "data-palette-color": "url(#09876789-79e1-4277-9fa3-6dc3b047cce7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "SvgjsG1446"
  })))))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", null))))))))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0.548,
    y2: 0.55,
    id: "be39c56c-9ba1-4356-9d84-da4f84de2937"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7366ff",
    offset: 1
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 360,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0fcbeb660b59ee863973e77a661fcab1.svg";
export { ForwardRef as ReactComponent };